import { setFilter, setFilterByNumber, setFilterBySportType, setSortByDate } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';

import { MainBlock, MobileFiltersToggle } from './styles';
import SearchInput from '../../elements/search-input';
import Select from '../../elements/select';
import { SportType } from 'modules/core/domain/enums/sport-type';
import _ from 'lodash';
import { onlyNumber } from 'shared/utils/regx/only-number';
import { selectOrganizersOptions } from '../../../store/selectors';
import { useTranslation } from 'react-i18next';
import React from 'react';

function Header() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { filterByNumber, filter, sortByDate, filterBySportType } = useSelector(selectOrganizersOptions);

  // mobile toggle state (ignored on desktop by CSS)
  const [open, setOpen] = React.useState(false);

  const filterByPhone = {
    headerText: 'Номер телефона:',
    value: filterByNumber,
    placeholder: '79139332245',
    parser: onlyNumber,
    onChange: (value: string) => {
      dispatch(setFilterByNumber(value));
    },
  };

  const searchInput = {
    headerText: 'Поиск по тексту:',
    value: filter,
    placeholder: 'Название, ФИО или город',
    onChange: (value: string) => {
      dispatch(setFilter(value));
    },
  };

  const sortByDateOptions = [
    { value: 'none', label: 'Все' },
    { value: 'desc', label: 'Новые' },
    { value: 'asc', label: 'Старые' },
  ];
  const sortByData = {
    headerText: 'Сортировать по дате:',
    options: sortByDateOptions,
    value: sortByDateOptions.find(({ value }) => value === sortByDate) ?? sortByDateOptions[0],
    onChange: (value: { label: string | number | JSX.Element; value: string } | undefined) => {
      const val = value?.value;
      dispatch(setSortByDate(val));
    },
  };

  const sportTypes = _.keys(SportType).map((key) => ({ value: key, label: _.capitalize(t('sportType.' + key)) }));
  sportTypes.unshift({ value: 'noneSet', label: 'Не задано' });
  sportTypes.unshift({ value: 'all', label: 'Все' });
  const filterBySport = {
    headerText: 'Тип спорта:',
    options: sportTypes,
    value: sportTypes.find(({ value }) => value === filterBySportType) ?? sportTypes[0],
    onChange: (value: { label: string | number | JSX.Element; value: string } | undefined) => {
      const val = value?.value;
      dispatch(setFilterBySportType(val as SportType));
    },
  };

  return (
    <>
      <MobileFiltersToggle onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls="organizers-filters">
        <span>Фильтры</span>
        <span aria-hidden>{open ? 'Скрыть' : 'Показать'}</span>
      </MobileFiltersToggle>
      <MainBlock id="organizers-filters" $open={open}>
        <SearchInput style={{ width: 451 }} {...searchInput} />
        <SearchInput style={{ width: 250 }} {...filterByPhone} />
        <Select style={{ width: 171 }} {...sortByData} />
        <Select style={{ flexGrow: 1 }} {...filterBySport} />
      </MainBlock>
    </>
  );
}

export default Header;
